import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    // Don't scroll on language switch (state.fromLangSwitch)
    if (location.state && location.state.fromLangSwitch) return;
    // Don't scroll if there's a hash (anchor navigation)
    if (location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname, location.hash, location.state]);
  return null;
}
